import { c as _c } from "react/compiler-runtime";
import { useSceneSeatPermission } from "@components/table/members/assign-seats/use-scene-seat-permission";
import { useErrorContext } from "@context-providers/error-boundary/error-handling-context";
import { useToast } from "@flat-ui";
import { WorkspaceEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { getPrettyName } from "@utils/user-utils";
/**
 * Returns how to take the SCENE seat of a member away again, so that it can be given to somebody
 * else. The seat is the `sceneSeat` permission of the member. The member keeps their workspace
 * membership, they only lose the access to SCENE.
 */
export function useRemoveSceneSeats() {
  const $ = _c(6);
  const {
    handleErrorWithToast
  } = useErrorContext();
  const {
    openToast
  } = useToast();
  const {
    trackEvent
  } = useTrackEvent();
  const {
    setSceneSeatPermission,
    refreshSeatUsage
  } = useSceneSeatPermission();
  let t0;
  if ($[0] !== handleErrorWithToast || $[1] !== openToast || $[2] !== refreshSeatUsage || $[3] !== setSceneSeatPermission || $[4] !== trackEvent) {
    const removeSceneSeats = async function removeSceneSeats(member) {
      trackEvent({
        name: WorkspaceEvents.unassignSceneSeat,
        props: {
          numberOfMembers: 1,
          location: "workspace-members-table"
        }
      });
      ;
      try {
        await setSceneSeatPermission(member, false);
        refreshSeatUsage();
        openToast({
          title: "SCENE seat removed",
          message: <><strong><var>{getPrettyName(member)}</var></strong>{" "}lost their SCENE seat, which is free again.</>
        });
        return true;
      } catch (t1) {
        const error = t1;
        handleErrorWithToast({
          id: `unassignSceneSeat-${Date.now().toString()}`,
          title: "Cannot remove the SCENE seat",
          error
        });
        return false;
      }
    };
    t0 = {
      removeSceneSeats
    };
    $[0] = handleErrorWithToast;
    $[1] = openToast;
    $[2] = refreshSeatUsage;
    $[3] = setSceneSeatPermission;
    $[4] = trackEvent;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  return t0;
}